module.exports = __webpack_public_path__ + "assets/img/loading.00218280.gif";